export function parseTotalTimeToDays(totalTime: string | null | undefined): number {
  if (!totalTime) return 0;

  let totalHours = 0;
  const value = String(totalTime);

  if (value.includes('days')) {
    const dayMatch = value.match(/(\d+)\s*days?/);
    const timeMatch = value.match(/(\d{1,2}):(\d{2}):(\d{2})/);

    const days = dayMatch ? parseInt(dayMatch[1], 10) : 0;
    let hours = 0;
    let minutes = 0;

    if (timeMatch) {
      hours = parseInt(timeMatch[1], 10);
      minutes = parseInt(timeMatch[2], 10);
    }

    totalHours = days * 24 + hours + minutes / 60;
  } else if (value.includes(':')) {
    const parts = value.split(':');
    const hours = parseInt(parts[0], 10) || 0;
    const minutes = parseInt(parts[1], 10) || 0;
    totalHours = hours + minutes / 60;
  }

  return totalHours / 24;
}

export function sumTotalTimeDays(rows: any[]): number {
  return (rows || []).reduce(
    (sum, row) => sum + parseTotalTimeToDays(row?.total_time),
    0,
  );
}
